import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { KioskLightProductDetailsPageConfig } from '@front-platform/content-builder';
import { kioskLightProductDetailsPageResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { AnalyticsService } from '@core/services/app/analytics.service';
export interface KioskLightProductDetailsPageRuntimeConfig {
  'body'?: any | undefined;
}

export type KioskLightProductDetailsPageConfigInput = Partial<
  Omit<KioskLightProductDetailsPageConfig, keyof KioskLightProductDetailsPageRuntimeConfig> &
    KioskLightProductDetailsPageRuntimeConfig
>;
export type KioskLightProductDetailsPageResolvedConfig = Omit<
  KioskLightProductDetailsPageConfig,
  keyof KioskLightProductDetailsPageRuntimeConfig
> &
  Partial<KioskLightProductDetailsPageRuntimeConfig>;
export interface KioskLightProductDetailsPageContract extends ConfigComponentContract<
  KioskLightProductDetailsPageConfigInput,
  KioskLightProductDetailsPageResolvedConfig
> {}

@Component({
  selector: 'app-kiosk-light-product-details-page',
  templateUrl: './kiosk-light-product-details-page.component.html',
  standalone: false,
})
export class KioskLightProductDetailsPageComponent
  implements OnInit, KioskLightProductDetailsPageContract
{
  readonly config = input<KioskLightProductDetailsPageConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    KioskLightProductDetailsPageConfig,
    KioskLightProductDetailsPageRuntimeConfig
  >(kioskLightProductDetailsPageResolveConfig, () => ({ config: this.config() }));
  get body(): any | undefined {
    return this.resolvedConfig()['body'] as unknown as any | undefined;
  }
  get backgroundColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['background_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get textColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor | undefined;
  }
  get buttonBackgroundColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['button_background_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get buttonTextColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['button_text_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }

  productId: string | null = null;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly analyticsService: AnalyticsService,
  ) {}

  ngOnInit(): void {
    this.updateProductId();
  }

  private updateProductId(): void {
    const productId = this.getProductIdFromRoute(this.route);

    if (productId) {
      this.productId = productId;
    } else {
      this.productId = null;
    }
  }

  private getProductIdFromRoute(route: ActivatedRoute): string | null {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.paramMap.get('productId');
  }

  back(): void {
    const shopCity = this.route.snapshot.paramMap.get('shopCity');
    const shopType = this.route.snapshot.paramMap.get('shopType');
    const shopSlug = this.route.snapshot.paramMap.get('shopSlug');

    this.router.navigate([`/fr/${shopCity}/${shopType}/${shopSlug}`]);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(KioskLightProductDetailsPageComponent, {
  'keyAliases': {},
});
